import { Component } from '@angular/core';

@Component({
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent { }



// WEBPACK FOOTER //
// ./src/app/modules/container/views/container.component.ts